// React packages and other npm packages
import { useTranslation } from "react-i18next";

// mui/material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  IconButton,
  Button,
  Box,
  Stack,
} from "@mui/material";

// mui/icons-material
import CloseIcon from "@mui/icons-material/Close";

const PaymentPopup = ({
  isOpen,
  invoiceId,
  totalAmount,
  paymentCards,
  selectedCard,
  onCardChange,
  onClose,
  onPayment,
  onNavigateToPaymentProfile,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        onClose={onClose}
        sx={{
          borderRadius: "20px",
          background: "transparent",

          minWidth: { xs: "300px", sm: "400px" },
        }}
      >
        <Stack
          sx={(theme) => ({
            background: theme.palette.common.black,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          })}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {`${t("Order.Pay For Invoice#")} ${invoiceId}`}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
              p: 1,
              borderRadius: "8px",
            })}
          >
            <CloseIcon />
          </IconButton>

          <DialogContent
            sx={(theme) => ({
              background: theme.palette.background.cardGradient,
              border: 0,
              borderBottomLeftRadius: "20px",
              borderBottomRightRadius: "20px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              minWidth: { xs: "250px", sm: "400px" },
            })}
            dividers
          >
            {paymentCards.length > 0 ? (
              <>
                <Typography sx={{ color: "var(--secondary-text)" }}>{`${t(
                  "Order.TOTAL"
                )} $${totalAmount}`}</Typography>
                <Typography
                  variant="h4"
                  sx={{ textAlign: "center", color: "var(--secondary-light)" }}
                >
                  {t("Order.Select Card To Pay Order")}
                </Typography>
                <RadioGroup value={selectedCard} onChange={onCardChange}>
                  {paymentCards.map((card) => (
                    <FormControlLabel
                      key={card.value}
                      value={card.value}
                      control={<Radio />}
                      label={card.label}
                    />
                  ))}
                </RadioGroup>
              </>
            ) : (
              <Box textAlign="center">
                <Typography
                  variant="h5"
                  sx={{ color: "var(--secondary.light)" }}
                  mb={1}
                  fontWeight={600}
                >
                  {t("Order.Payment Profile Is Not Available")}
                </Typography>
                <Button
                  variant="text"
                  sx={{ textDecoration: "underline", fontWeight: 600 }}
                  onClick={onNavigateToPaymentProfile}
                >
                  {t("Order.Go To Payment Profile")}
                </Button>
              </Box>
            )}

            <Stack
              direction={"row"}
              gap={1}
              width={"100%"}
              alignItems={"center"}
              justifyContent={"space-between"}
              flexWrap={"wrap"}
            >
              <Button
                variant="contained"
                color="secondary"
                sx={{ px: 3 }}
                onClick={onClose}
              >
                {t("Common.Cancel")}
              </Button>
              {paymentCards.length > 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ px: 3 }}
                  onClick={onPayment}
                >
                  {t("Order.Pay")}
                </Button>
              )}
            </Stack>
          </DialogContent>
        </Stack>
      </Dialog>
    </>
  );
};

export default PaymentPopup;
